import React from 'react';

const IITChallenge2025: React.FC = () => {
  return (
    <div className="text-justify py-4">
      
      <p className="mb-4">
        Pada 5 Oktober 2025, <b>Indonesia Innovative Technology Challenge (IIT Challenge)</b> berhasil menggelar ajang tahunan yang memacu kreativitas dan inovasi generasi muda. Acara ini diselenggarakan dengan gemilang, menarik total <b>225 peserta</b> dari <b>92 sekolah</b> yang tersebar di berbagai daerah di Indonesia.
      </p>
      
      <p className="mb-6">
        Kompetisi ini bertujuan untuk menginspirasi pelajar agar lebih antusias dalam mengeksplorasi teknologi dan sains, dengan menggabungkan elemen inovasi, kolaborasi, dan kompetisi dalam suasana yang positif dan mendidik.
      </p>
      
      <h2 className="text-2xl font-bold mb-4">Ragam Kompetisi di IIT Challenge 2025</h2>
      <p className="mb-4">
        IIT Challenge 2025 menghadirkan lima kategori lomba menarik, yang dirancang untuk menantang kemampuan analitis, kreativitas, dan teknis para peserta:
      </p>
      
      <ol className="list-decimal pl-6 mb-6 space-y-6">
        <li>
          <p><strong>Innovative Technology Challenge (Junior dan Senior)</strong></p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li><b>Level Junior</b> untuk siswa sekolah dasar.</li>
            <li><b>Level Senior</b> untuk siswa Sekolah Menengah Pertama (SMP) dan Sekolah Menengah Atas (SMA).</li>
          </ul>
          <p className="mt-2">
            Dalam lomba ini, peserta diminta mengembangkan solusi teknologi inovatif untuk mengatasi masalah yang relevan dengan kehidupan sehari-hari.
          </p>
        </li>
        
        <li>
          <p><strong>Coding Python</strong></p>
          <p>
            Kompetisi pemrograman ini terbuka untuk siswa SMP dan SMA, yang bertujuan untuk menguji kemampuan mereka dalam menyelesaikan tantangan logika dan algoritma menggunakan Python.
          </p>
        </li>
        
        <li>
          <p><strong>Student Symposium Research Paper</strong></p>
          <p>
            Terbuka untuk siswa SMP dan SMA, kategori ini memberikan ruang bagi para peserta untuk mempresentasikan hasil penelitian mereka di bidang sains, teknologi, dan inovasi dalam format simposium.
          </p>
        </li>
        
        <li>
          <p><strong>Sumo Robot</strong></p>
          <p>
            Kompetisi robotik yang mengadu ketangkasan robot dalam pertempuran sumo robot dengan bobot 1 KG, kategori ini menuntut kemampuan desain dan strategi robotik yang unggul dari peserta SMP dan SMA.
          </p>
        </li>
        
        <li>
          <p><strong>Obstacle Avoidance Driving Game Robot</strong></p>
          <p>
            Kategori ini menantang peserta SMP dan SMA untuk merancang robot yang mampu bermanuver menghindari berbagai rintangan dalam sebuah arena kompetisi.
          </p>
        </li>
      </ol>
      
      <h2 className="text-2xl font-bold mb-4">Antusiasme Peserta dan Keberhasilan Acara</h2>
      <p className="mb-4">
        Dengan partisipasi yang melibatkan <b>92 sekolah </b>, IIT Challenge 2025 telah membuktikan diri sebagai platform yang mendukung perkembangan teknologi dan pendidikan di kalangan generasi muda. Ajang ini juga menjadi bukti bahwa anak-anak Indonesia memiliki potensi besar untuk bersaing di kancah teknologi global.
      </p>
      
      <p className="mb-6">
        Acara seperti IIT Challenge 2025 tidak hanya mencetak juara, tetapi juga mencetak inovator muda yang berpotensi menjadi pemimpin masa depan dalam dunia teknologi. Mari dukung generasi muda Indonesia untuk terus berkembang dan berinovasi!
      </p>
      
      <h2 className="text-2xl font-bold mb-4">Lihat Keseruannya di Instagram</h2>
      <p className="mb-4">
        Untuk informasi lebih lanjut dan momen seru lainnya dari IIT Challenge 2025, kunjungi Instagram kami di <a href="https://instagram.com/iitchallenge2025" target='_blank' className="underline font-semibold text-defaultBlue">@iitchallenge2025</a>.
      </p>
      
      <p>
        Temukan inspirasi dari karya-karya luar biasa generasi muda Indonesia dan persiapkan dirimu untuk tantangan selanjutnya! Mari terus dukung pengembangan teknologi dan inovasi di Indonesia!
      </p>
    </div>
  );
};

export default IITChallenge2025;